import { Box, ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

import { checkIsDarkTheme } from '@helpers/theme';

export const BurgerMenuButtonStyled = styled(ButtonBase)({
  borderRadius: 0,
  overflow: 'hidden',
});

export const BurgerMenuButtonIconWrapperStyled = styled(Box)(({ theme }) => {
  const isDarkTheme = checkIsDarkTheme(theme);

  return {
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all .2s ease-in-out',
    backgroundColor: isDarkTheme
      ? theme.palette.dark.main
      : theme.palette.secondary.light,
    color: isDarkTheme
      ? theme.palette.secondary.main
      : theme.palette.secondary.dark,

    '&:hover': {
      backgroundColor: isDarkTheme
        ? theme.palette.secondary.main
        : theme.palette.secondary.dark,
      color: isDarkTheme
        ? theme.palette.secondary.light
        : theme.palette.secondary.light,
    },
  };
});
